import { Box, Chip, makeStyles, Tooltip } from '@material-ui/core';
import { toMonetary } from 'lib/Utility';
import * as React from 'react';

const useStyles = makeStyles((theme) => ({
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.75),
    marginTop: theme.spacing(0.75),
  },
  chip: {
    height: 22,
    fontSize: 11,
    fontWeight: 600,
  },
  unknownCountry: {
    color: theme.palette.warning.dark,
    borderColor: theme.palette.warning.main,
  },
}));

interface Props {
  country?: string | null;
  hexaco?: number | null;
  salary?: number | null;
  isNli?: boolean | null;
  tcnTypeId?: number | null;
  // result cards: say so when the country is missing, they may not be in malta
  flagMissingCountry?: boolean;
}

function formatHexaco(value: number): string {
  return Number.isInteger(value) ? value.toFixed(0) : value.toFixed(1);
}

function getTcnLabel(tcnTypeId?: number | null): string | null {
  if (tcnTypeId === 1) return 'Valid TCN';
  if (tcnTypeId === 2 || tcnTypeId === 3) return 'Invalid TCN';
  return null;
}

export const CandidateMetadataChips: React.FC<Props> = ({
  country,
  hexaco,
  salary,
  isNli,
  tcnTypeId,
  flagMissingCountry = false,
}) => {
  const classes = useStyles();
  const tcnLabel = getTcnLabel(tcnTypeId);

  const showUnknownCountry = flagMissingCountry && !country;

  if (
    !country &&
    !showUnknownCountry &&
    hexaco == null &&
    salary == null &&
    isNli == null &&
    !tcnLabel
  ) {
    return null;
  }

  return (
    <Box className={classes.chips}>
      {country && (
        <Chip className={classes.chip} label={country} size="small" />
      )}
      {showUnknownCountry && (
        <Tooltip title="No country on this profile, because you picked 'Malta and Unknown'. They may not live in Malta.">
          <Chip
            className={`${classes.chip} ${classes.unknownCountry}`}
            label="Country unknown"
            size="small"
            variant="outlined"
          />
        </Tooltip>
      )}
      {hexaco != null && (
        <Chip
          className={classes.chip}
          label={`HEXACO ${formatHexaco(hexaco)}`}
          size="small"
        />
      )}
      {salary != null && (
        <Chip
          className={classes.chip}
          label={toMonetary(salary)}
          size="small"
        />
      )}
      {isNli != null && (
        <Chip
          className={classes.chip}
          label={isNli ? 'NLI' : 'Non-NLI'}
          size="small"
        />
      )}
      {tcnLabel && (
        <Chip className={classes.chip} label={tcnLabel} size="small" />
      )}
    </Box>
  );
};
